// ============================================================
// SelectionDevis — cocher des brouillons et les supprimer ensemble.
// 6 octobre 2026.
// ------------------------------------------------------------
// Philippe faisait le ménage devis par devis. On coche, on relit la liste
// des références, on confirme.
//
// BROUILLONS SEULEMENT : un devis remis à un client se supprime un par
// un, par un administrateur, en recopiant sa référence. La case est
// inactive sur les autres — et le serveur refuserait de toute façon.
//
// Chaque suppression passe par la route habituelle, donc par
// `deleteDevis` : journal d'audit et effacement des plans conservés. Une
// suppression groupée n'est pas une autre porte.
// ============================================================

import { useState } from 'react';
import Modal from '../../ui/Modal.jsx';
import Button from '../../ui/Button.jsx';
import { api } from '../../lib/api.js';

export function useSelectionDevis({ toast, onFait }) {
  const [coches, setCoches] = useState(() => new Map());
  const [ouvert, setOuvert] = useState(false);
  const [envoi, setEnvoi] = useState(false);

  const basculer = (d) => setCoches((m) => {
    const n = new Map(m);
    if (n.has(d.id)) n.delete(d.id); else n.set(d.id, d);
    return n;
  });

  const colonne = {
    key: 'selection',
    label: '',
    render: (d) => (
      <input
        type="checkbox"
        aria-label={`Sélectionner le devis ${d.reference}`}
        title={d.status === 'draft' ? undefined : 'Seul un brouillon se supprime en groupe'}
        disabled={d.status !== 'draft'}
        checked={coches.has(d.id)}
        onChange={() => basculer(d)}
      />
    ),
  };

  async function supprimer() {
    setEnvoi(true);
    const echecs = [];
    for (const d of coches.values()) {
      try {
        // eslint-disable-next-line no-await-in-loop
        await api.delete(`/devis/${d.id}`);
      } catch (err) {
        echecs.push(`${d.reference} : ${err.message}`);
      }
    }
    const n = coches.size - echecs.length;
    if (n) toast.success(`${n} devis supprimé(s).`);
    if (echecs.length) toast.error(`Non supprimé(s) — ${echecs.join(' ; ')}`);
    setCoches(new Map());
    setOuvert(false);
    setEnvoi(false);
    onFait?.();
  }

  const barre = coches.size ? (
    <>
      <Button size="sm" variant="danger" onClick={() => setOuvert(true)}>
        Supprimer la sélection ({coches.size})
      </Button>
      <Modal
        open={ouvert}
        onClose={() => !envoi && setOuvert(false)}
        title={`Supprimer ${coches.size} brouillon(s) ?`}
        footer={(
          <>
            <Button variant="secondary" onClick={() => setOuvert(false)} disabled={envoi}>Annuler</Button>
            <Button variant="danger" onClick={supprimer} disabled={envoi}>
              {envoi ? 'Suppression…' : 'Supprimer'}
            </Button>
          </>
        )}
      >
        <div className="stack">
          <ul>
            {[...coches.values()].map((d) => (
              <li key={d.id}>
                <strong>{d.reference}</strong>
                {d.client_company ? ` — ${d.client_company}` : ''} · {d.piece_count ?? 0} pièce(s)
              </li>
            ))}
          </ul>
          <p>
            Définitif : les pièces, leur gamme et les plans du client sont effacés. Seule la
            sauvegarde de la nuit permettrait de revenir en arrière.
          </p>
        </div>
      </Modal>
    </>
  ) : null;

  return { colonne, barre };
}

export default useSelectionDevis;
